// imports
import _get from 'lodash/get';
import Config from '$root/Config';
import BinModel from '../../models/bin/BinModel';
import MinskyCollection from '../MinskyCollection';

// class definition
export default class BinCollection extends MinskyCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinModel;
		
		// call super constructor
		super(args);

		this.projectId = null;

		this.urlDictionary = {
			title: 'titel',
			color: 'kleur'
		}
	}

	fetch(preventClear) {
		this.setConfig('url', `${Config.getUrl('c_bins')}`);
		if (this.config.params.activeState) {
			if (this.config.params.activeState === 'all') {
				this.config.params.status = [];
				delete this.config.params.activeState;
			} else if (this.config.params.activeState === 'non-active') {
				this.config.params.status = [false];
				delete this.config.params.activeState;
			}
		}
		return super.fetch(preventClear);
	}

	parse(data) {
		data.data.map(item => {
			const newModel = new this.Model().parse({data: item});
			return newModel;
		});

		return super.parse(data);
	}

	bulkSet(model) {
		// convert to object to avoid any mistakes
		if (model instanceof Model) model = model.toObject(true);

		// loop over all & apply values
		this.each((_, item) => {
			item.set(model);
		});

		return this;
	}
}
